import React, { useEffect, useState } from 'react';
import api from '@/api/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard/stats').then(({ data }) => {
      if (data.success) setStats(data.data);
    }).catch(() => toast.error('Erro ao carregar dashboard'));
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {stats ? (
          <>
            <MetricCard title="Motoristas" value={stats.drivers || 0} />
            <MetricCard title="Viaturas" value={stats.vehicles || 0} />
            <MetricCard title="Viagens" value={stats.trips || 0} />
            <MetricCard title="Liquidações" value={stats.payouts || 0} />
          </>
        ) : (
          <>
            <MetricCard title="Motoristas" value="-" />
            <MetricCard title="Viaturas" value="-" />
            <MetricCard title="Viagens" value="-" />
            <MetricCard title="Liquidações" value="-" />
          </>
        )}
      </div>
    </div>
  );
}

function MetricCard({ title, value }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold">{value}</div>
      </CardContent>
    </Card>
  );
}
